import { transactionHelpersLabels } from '../constants/accountPanelConfigs';
export const getTransactionMethod = (
  customer_type: string,
  client_type: string,
  description: string | undefined
) => {
  const {
    customer_type_ledger,
    cash,
    cheque,
    offline,
    online,
    client_type_front_end,
  } = transactionHelpersLabels;
  const transactionMethod =
    customer_type.toUpperCase() === customer_type_ledger.toUpperCase() &&
    client_type.toUpperCase() === client_type_front_end.toUpperCase()
      ? online
      : description &&
        (description.toUpperCase() === cash.toUpperCase() ||
          description === cheque.toUpperCase())
      ? description
      : offline;
  return transactionMethod;
};

export const convertDateFormat = (inDate: string) => {
  const transactionDate = new Date(inDate);
  const date = transactionDate.getDate();
  const month = transactionDate.getMonth() + 1;
  const year = transactionDate.getFullYear();
  return ` ${month <= 9 ? '0' + month : month}/${
    date <= 9 ? '0' + date : date
  }/${year} `;
};
